<h1 mat-dialog-title class="p-2 text-center">Recherche de clients</h1>
<div mat-dialog-content class="p-3 overflow-hidden">
    <div class="container-fluid d-flex flex-column" style="max-height: 500px">

        <div class="row" style="flex: 0 0 60px;">
            <mat-form-field class="col-6 mb-3" >
                <input matInput [(ngModel)]="searchText" placeholder="Code ou Nom de client" (keyup.enter)="searchNewClient()">
            </mat-form-field>
            <button appPreventDoubleClick class="col-auto" color="primary" mat-mini-fab (throttledClick)="searchNewClient()">
                <mat-icon class="material-symbols-outlined"> search </mat-icon>
            </button>
        </div>

        <div *ngIf="AvailableClientList.length === 0" style="flex-grow: 1;"></div>
        <mat-selection-list class="row d-flex " style="flex-grow: 1; overflow-y: auto;" *ngIf="AvailableClientList.length >= 1" (selectionChange)="setSelectedClients($event)" multiple>
            <h3 matSubheader>Clients</h3>
            <mat-list-option class="col-12" *ngFor="let c of AvailableClientList" [value]="c" >
                <mat-icon class="material-symbols-outlined" mat-list-icon>face</mat-icon>
                {{c.Name}} - {{c.City}} ({{c.Code}})
                <mat-divider></mat-divider>
            </mat-list-option>
        </mat-selection-list>

        <div class="row mt-3 g-0" style="flex: 0 0 60px;">
            <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
                Annuler
            </button>
            <button appPreventDoubleClick class="col ms-1" color="accent" mat-raised-button (throttledClick)="onConfirm()" [disabled]="!CanAdd()">
                Ajouter
            </button>
        </div>
    </div>
</div>